/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Thanks_BodyInputs */

const en_us2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your trainer will use your feedback to adjust the next workout.`)
};

const pt_br2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu personal vai usar sua avaliação para ajustar o próximo treino.`)
};

const es_419_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu entrenador usará tu opinión para ajustar el próximo entrenamiento.`)
};

const pt_pt2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu treinador vai usar a tua avaliação para ajustar o próximo treino.`)
};

const fr_fr2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton coach utilisera ton avis pour ajuster la prochaine séance.`)
};

const de_de2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Coach nutzt dein Feedback, um das nächste Training anzupassen.`)
};

const it_it2_workout_after_thanks_body = /** @type {(inputs: Workout_After_Thanks_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach userà il tuo feedback per regolare il prossimo allenamento.`)
};

/**
* | output |
* | --- |
* | "Your trainer will use your feedback to adjust the next workout." |
*
* @param {Workout_After_Thanks_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_thanks_body = /** @type {((inputs?: Workout_After_Thanks_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Thanks_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_thanks_body(inputs)
	if (locale === "es-419") return es_419_workout_after_thanks_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_thanks_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_thanks_body(inputs)
	if (locale === "de-DE") return de_de2_workout_after_thanks_body(inputs)
	if (locale === "it-IT") return it_it2_workout_after_thanks_body(inputs)
	return en_us2_workout_after_thanks_body(inputs)
});
export { workout_after_thanks_body as "workout-after.thanks_body" }